import { IconProps } from "../../types/utils";

const InCompleteIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 16}
    height={dimension || 17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.910278" width="15" height="15" stroke="#6DA588" />
  </svg>
);

export default InCompleteIcon;
